module.exports = __webpack_public_path__ + "static/img/logo.dd0bb47a.png";